import {IComponentOptions, IHttpPromiseCallbackArg, ILogService} from 'angular';
import {OkHtmlDialogController} from '../../../core/dialog/OkHtmlDialogController';
import {DvDialog} from '../../../core/directive/dv-dialog/dv-dialog';
import AnlaufstelleRS from '../../../core/service/AnlaufstelleRS.rest';
import BenutzerRS from '../../../core/service/BenutzerRS.rest';
import ZahlungsauftragRS from '../../../core/service/ZahlungsauftragRS.rest';
import {TSRole} from '../../../models/enums/TSRole';
import {getTSSchadenfallStatusalues, TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';
import TSAnlaufstelle from '../../../models/TSAnlaufstelle';
import TSApplicationProperty from '../../../models/TSApplicationProperty';
import TSBenutzer from '../../../models/TSBenutzer';
import TSSerfProperty from '../../../models/TSSerfProperty';
import DVBernUtil from '../../../utils/DVBernUtil';
import {ApplicationPropertyRS} from '../../service/applicationPropertyRS.rest';
import {SerfPropertyRS} from '../../service/serfPropertyRS.rest';
import {TestFaelleRS} from '../../service/testFaelleRS.rest';
import IPromise = angular.IPromise;

require('./adminView.scss');
let template = require('./adminView.html');
let okHtmlDialogTemplate = require('../../../core/dialog/okHtmlDialogTemplate.html');

export class AdminViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    bindings: any = {
        applicationProperties: '<',
        serfProperties: '<'
    };
    template: string = template;
    controller: any = AdminViewController;
    controllerAs: string = 'vm';
}

export class AdminViewController {
    static $inject = ['ApplicationPropertyRS', 'MAX_LENGTH', 'DvDialog', 'TestFaelleRS', 'AnlaufstelleRS', 'BenutzerRS', 'SerfPropertyRS', '$log', 'ZahlungsauftragRS'];

    length: number;
    applicationProperty: TSApplicationProperty = new TSApplicationProperty();
    applicationPropertyRS: ApplicationPropertyRS;
    applicationProperties: TSApplicationProperty[];
    schadenfallStatus: TSSchadenfallStatus = TSSchadenfallStatus.NEU;
    anzahl: number = 1;
    schadenfallnummer: string | undefined;
    benutzerEmail: string | undefined;
    anlaufstellen: Array<TSAnlaufstelle>;
    anlaufstelle: TSAnlaufstelle;
    besitzerListe: Array<TSBenutzer>;
    besitzer: TSBenutzer;
    serfProperty: TSSerfProperty = new TSSerfProperty();
    serfProperties: TSSerfProperty[];
    zahlungsAuftragId: string;
    devFunctionsEnabled: boolean;

    /* @ngInject */
    constructor(applicationPropertyRS: ApplicationPropertyRS, MAX_LENGTH: number, private dvDialog: DvDialog,
                private testFaelleRS: TestFaelleRS, private anlaufstelleRS: AnlaufstelleRS, private benutzerRS: BenutzerRS,
                private serfPropertyRS: SerfPropertyRS, private $log: ILogService, private zahlungsauftragRS: ZahlungsauftragRS) {
        this.length = MAX_LENGTH;
        this.applicationPropertyRS = applicationPropertyRS;

    }

    $onInit() {

        this.anlaufstelleRS.getAllAnlaufstellen().then((response) => {
            this.anlaufstellen = response;
        });

        this.benutzerRS.allBenutzerForRole(TSRole.BETROFFENER).then((response) => {
            this.besitzerListe = response;
        });
    }

    submit(): void {
        //testen ob aktuelles property schon gespeichert ist
        if (this.applicationProperty && this.applicationProperty.name) {
            if (!this.applicationProperty.isNew()) {
                this.applicationPropertyRS.update(this.applicationProperty.name, this.applicationProperty.value)
                    .then((response: TSApplicationProperty) => {
                        let index = DVBernUtil.getIndexOfElementwithIDById(response.id, this.applicationProperties);
                        this.applicationProperties[index] = response;
                    });

            } else {

                this.applicationPropertyRS.create(this.applicationProperty.name, this.applicationProperty.value)
                    .then((response: any) => {
                        this.applicationProperties = this.applicationProperties.concat(response);
                    });
            }
            this.resetForm();
        }
    }

    submitSerfProperty(): void {
        //testen ob aktuelles property schon gespeichert ist
        if (this.serfProperty && this.serfProperty.name) {
            if (!this.serfProperty.isNew()) {
                this.serfPropertyRS.update(this.serfProperty.name, this.serfProperty.value)
                    .then((response: TSSerfProperty) => {
                        let index = DVBernUtil.getIndexOfElementwithIDById(response.id, this.serfProperties);
                        this.serfProperties[index] = response;
                    });

            } else {

                this.serfPropertyRS.create(this.serfProperty.name, this.serfProperty.value)
                    .then((response: any) => {
                        this.serfProperties = this.serfProperties.concat(response);
                    });
            }
            this.resetForm();
        }
    }

    removeRow(row: TSApplicationProperty): void {
        if (row.name) {
            this.applicationPropertyRS.remove(row.name).then((reponse: IHttpPromiseCallbackArg<any>) => {
                let index = this.applicationProperties.indexOf(row);
                if (index !== -1) {
                    this.applicationProperties.splice(index, 1);
                    this.resetForm();
                }
            });
        }
    }

    removeSerfProperty(serfProperty: TSSerfProperty): void {
        if (serfProperty.name) {
            this.serfPropertyRS.remove(serfProperty.name).then((reponse: IHttpPromiseCallbackArg<any>) => {
                let index = this.serfProperties.indexOf(serfProperty);
                if (index !== -1) {
                    this.serfProperties.splice(index, 1);
                    this.resetForm();
                }
            });
        }
    }

    createItem(): void {
        this.applicationProperty = new TSApplicationProperty('', '');
    }

    editRow(row: TSApplicationProperty): void {
        this.applicationProperty = row;
    }

    editSerfProperty(serfProperty: TSSerfProperty): void {
        this.serfProperty = serfProperty;
    }

    resetForm(): void {
        this.applicationProperty = new TSApplicationProperty();
        this.serfProperty = new TSSerfProperty();
    }

    public getVersion(): string {
        return VERSION;
    }

    public getBuildtimestamp(): string {
        return BUILDTSTAMP;
    }

    public getSchadenfallStatusList(): Array<TSSchadenfallStatus> {
        return getTSSchadenfallStatusalues();
    }

    public createTestFallType(testFall: string): IPromise<any> {
        let anlaufstelleId: string = 'undefined';
        let besitzerId: string = 'undefined';

        if (this.anlaufstelle) {
            anlaufstelleId = this.anlaufstelle.id;
        }
        if (this.besitzer) {
            besitzerId = this.besitzer.id;
        }

        return this.testFaelleRS.createTestFall(testFall, this.schadenfallStatus, anlaufstelleId, this.anzahl, besitzerId).then((response) => {
            return this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController, {
                title: 'Testfall created',
                text: response.data
            }).then(() => {
                //do nothin
            });
        });
    }

    public createVersicherungsbeitragFallTest(): IPromise<any> {

        return this.testFaelleRS.createTestFallVersicherungsbeitrag(this.schadenfallStatus, this.anzahl).then((response) => {
            return this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController, {
                title: 'Testfall created',
                text: response.data
            }).then(() => {
                //do nothin
            });
        });
    }

    public sendTestMail(mail: string) {
        if (this.schadenfallnummer) {

            this.testFaelleRS.sendTestMail(this.schadenfallnummer, mail).then((response) => {
                return this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController, {
                    title: 'Test email',
                    text: response.data
                }).then(() => {
                    //do nothin
                });
            });
        }
    }

    public getAnlaufstelleList(): Array<TSAnlaufstelle> {
        return this.anlaufstellen;
    }

    public getBesitzerList(): Array<TSBenutzer> {
        return this.besitzerListe;
    }

    public resetUserRoles() {
        if (this.benutzerEmail) {
            this.benutzerRS.resetUserRoles(this.benutzerEmail).then((response) => {
                return this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController, {
                    title: 'Benutzer-Rollen zurücksetzen',
                    text: response
                }).then(() => {
                    //do nothin
                });
            });
        }
    }

    public removeBetroffeneRole() {
        if (this.benutzerEmail) {
            this.benutzerRS.removeBetroffeneRole(this.benutzerEmail).then((response) => {
                return this.dvDialog.showDialog(okHtmlDialogTemplate, OkHtmlDialogController, {
                    title: 'Benutzer-Rollen zurücksetzen',
                    text: response
                }).then(() => {
                    //do nothin
                });
            });
        }
    }

    public recreateZahlungsauftragExcel() {
        // special case, workaround so we can correct wrongly generated excels
        if (this.zahlungsAuftragId) {
            this.$log.debug('recreating Zahlungsauftrag excel, regenerating for Zahlungsauftrag ' + this.zahlungsAuftragId);
            this.zahlungsauftragRS.regenerateExcel(this.zahlungsAuftragId).then(dokId => {
                this.$log.info('created new document with id ' + dokId);
                this.zahlungsAuftragId = '';
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/component/adminView/adminView.ts